import { Component, Vue, Prop } from 'vue-property-decorator';
import KnowledgePanel from '../knowledge-panel/knowledge-panel';
import CommunityPanel from '../community-panel/community-panel';
import MindsetsPanel from '../mindsets-panel/mindsets-panel';
import { SubjectModel } from '@/models/taxonomy/subject';
import { ClassificationModel } from '@/models/taxonomy/classification';

import { Domain } from '@/models/proficiency/domain-topic/domain';
import { Topic } from '@/models/proficiency/domain-topic/topic';
import { Competency } from '@/models/proficiency/domain-topic/competency';

import moment from 'moment';
import SubjectJourneyComponent from '../subject-journey-panel/subject-journey-panel';
import { UserClassModel } from '@/models/class/class';

@Component({
  name: 'subject-info-panel',
  components: {
    'mindsets-panel': MindsetsPanel,
    'knowledge-panel': KnowledgePanel,
    'community-panel': CommunityPanel,
    'journey-panel': SubjectJourneyComponent,
  },
})

export default class SubjectInfoPanel extends Vue {

  @Prop()
  public classification!: ClassificationModel;

  @Prop()
  public subject!: SubjectModel;

  @Prop()
  public activeClasses!: UserClassModel[];

  @Prop()
  public isShowcasePage!: boolean;

  public activeTab: object = {
    title: 'Knowledge',
    component: 'knowledge-panel',
  };

  public tabItems = [
    {
      title: 'Knowledge',
      component: 'knowledge-panel',
    },
    {
      title: this.isShowcasePage ? 'Journey' : 'Mindset',
      component: this.isShowcasePage ? 'journey-panel' : 'mindsets-panel',
    },
    {
      title: 'Citizenship',
      component: 'community-panel',
    },
  ];

  @Prop()
  private activeToggleList?: string;

  @Prop()
  private month!: string;

  @Prop()
  private year!: string;

  @Prop()
  private userId!: string;

  private get isSuperUser() {
    return this.$access.hasPermission('all', 'all');
  }


  public onSelectDomain(domain: any) {
    this.$emit('onSelectDomain', domain);
  }

  public onSelectCompetency(competency: any) {

    this.$emit('onSelectCompetency', competency);
  }

  public onSelectTopic(topic: Topic) {
    this.$emit('onSelectTopic', topic);
  }

  private onSelectPortfolioStat(portfolio: any) {
    this.$emit('onSelectPortfolioStat', portfolio);
  }

}
